"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNonCommsMeter = void 0;
var date_fns_1 = require("date-fns");
var constants_1 = require("../constants");
var utils_1 = require("./utils");
// A smart meter is considered non-comms if it's smart and either:
// - has no reads of type "SmartReading", or
// - the most recent read of type "SmartReading" was longer than `SMART_METER_NON_COMMS_DAYS` days ago
function isNonCommsMeter(isSmart, readings) {
    if (!isSmart) {
        return false;
    }
    if (!readings || readings.length === 0) {
        return true;
    }
    var latestSmartMeterReadings = readings
        .filter(function (readings) { return readings.readingType === 'SmartReading'; })
        .sort(utils_1.mostRecentFirst);
    if (latestSmartMeterReadings.length === 0) {
        return true;
    }
    var nonCommsCutOff = (0, date_fns_1.subDays)((0, date_fns_1.startOfToday)(), constants_1.SMART_METER_NON_COMMS_DAYS);
    return (0, date_fns_1.isBefore)(latestSmartMeterReadings[0].formattedReadingDate, nonCommsCutOff);
}
exports.isNonCommsMeter = isNonCommsMeter;
